import { supabase } from '../../core/config/supabase';
import { MatchEntity } from '../entities';

export class MatchDataSource {
  async create(match: Omit<MatchEntity, 'id' | 'created_at' | 'updated_at'>): Promise<MatchEntity> {
    const { data, error } = await supabase
      .from('matches')
      .insert(match)
      .select()
      .single();

    if (error) throw new Error(error.message);
    if (!data) throw new Error('No data returned from insert');

    return data as MatchEntity;
  }

  async getById(id: string): Promise<MatchEntity | null> {
    const { data, error } = await supabase
      .from('matches')
      .select('*')
      .eq('id', id)
      .single();

    if (error) {
      if (error.code === 'PGRST116') return null; // Not found
      throw new Error(error.message);
    }

    return data as MatchEntity;
  }

  async getByTournamentId(tournamentId: string): Promise<MatchEntity[]> {
    const { data, error } = await supabase
      .from('matches')
      .select('*')
      .eq('tournament_id', tournamentId)
      .order('bracket_type', { ascending: true })
      .order('round', { ascending: true })
      .order('match_number', { ascending: true });

    if (error) throw new Error(error.message);

    return (data as MatchEntity[]) || [];
  }

  async update(id: string, match: Partial<MatchEntity>): Promise<MatchEntity> {
    const { data, error } = await supabase
      .from('matches')
      .update({ ...match, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();

    if (error) throw new Error(error.message);
    if (!data) throw new Error('No data returned from update');

    return data as MatchEntity;
  }

  async delete(id: string): Promise<void> {
    const { error } = await supabase
      .from('matches')
      .delete()
      .eq('id', id);

    if (error) throw new Error(error.message);
  }
}
